import { render, staticRenderFns } from "./ManageFrequentlyAskedQuestions.vue?vue&type=template&id=261fd1d9&scoped=true&"
import script from "./ManageFrequentlyAskedQuestions.vue?vue&type=script&lang=js&"
export * from "./ManageFrequentlyAskedQuestions.vue?vue&type=script&lang=js&"
import style0 from "./ManageFrequentlyAskedQuestions.vue?vue&type=style&index=0&id=261fd1d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261fd1d9",
  null
  
)

export default component.exports